export type ExcludeCu<T> = Exclude<T, { creativeUnitsCost: number }>;

export const removeCuFromType = <T extends object>(value: T) => {
  const newValue = { ...value };
  if ("creativeUnitsCost" in newValue) {
    delete newValue.creativeUnitsCost;
  }
  return newValue as unknown as ExcludeCu<typeof newValue>;
};
